import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Icon,
  Button,
  Input,
  Checkbox,
  message,
  Select,
  Switch,
  Collapse,
  Modal,
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import index, { Translate } from "react-translated";
import Dropzone from 'react-dropzone'
import Microsoft_booking from "./microsoft_booking";
import ManualMicrosoftBooking from "./manual_microsoft_booking";
import SchedulingLink from "./Components/SchedulingLink";
import { ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_IMAGE, FAILED_TO_REMOVE_PROFILE_PHOTO, NO, PROFILE_PHOTO_REMOVED_SUCCESSFULLY, SOMETHING_WENT_WRONG, TYPE_OF_SCHEDULING_CALL, UPDATE_PROFILE, YES } from "../../utils/Constants";
import { DELETE_LSP_USER_DP_URL } from "../../utils/Api_enums";

const Option = Select.Option;
const { TextArea } = Input;
const { Panel } = Collapse;

class Profile extends Component {
  state = {
    pass_loading: false,
  };
  copyToClipboard = (e) => {
    window.document.getElementById("linkTextarea").select();
    window.document.execCommand("copy");
    window.document.getElementById("linkTextarea").focus();
    message.success("Copied!");
  };

  showDeleteConfirm = (type, index = null) => {
    Modal.confirm({
      title: ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_IMAGE,
      okText: YES,
      cancelText: NO,
      onOk: () => {
        if (type === "profile_pic") {
          const newPics = [...this.props.fileAttributes[type]];
          newPics.splice(index, 1);
          this.props.fileAttributes_upload([type], {
            ...this.props.fileAttributes,
            [type]: newPics,
          });
          message.success(PROFILE_PHOTO_REMOVED_SUCCESSFULLY);
        } else {
          //for dp_url
          axios.post(DELETE_LSP_USER_DP_URL, {
            user_id: index
          }).then((res) => {
            if (res.data.success) {
              message.success(res.data.message);
            } else {
              message.error(res.data.message || FAILED_TO_REMOVE_PROFILE_PHOTO);
            }
          }).catch(err => {
            message.error(SOMETHING_WENT_WRONG);
          }).finally(() => {
            setTimeout(() => window.location.reload(), 300);
          })
        }
      }
    })
  }


  render() {
    const { loading, user, updateField, update, fileAttributes, fileAttributes_upload } = this.props;
    const userType = this.props.parentInstance.props.auth.user.user_type;

    let link = "";
    if (user.user_agency_assoc.length > 0) {
      link =
        "https://bfilesystem.com/app/create-bfile/" +
        user.user_agency_assoc[0].agency_id +
        "/" +
        user.id;
    }

    const calendly_connect = F.isProductionHost()
      ? "https://auth.calendly.com/oauth/authorize?client_id=TOmzViVrU2VxnA9XAxFyLwRBJB3wFqZso2Y45b3BlEA&response_type=code&redirect_uri=https://bfilesystem.com/api/auth/calendly"
      : window.location.host === 'bfiledev.netlink.com' ? "https://auth.calendly.com/oauth/authorize?client_id=hUALsvqvT91JNB8crNJiAhQZGwRB09jriZsLfXfhG_E&response_type=code&redirect_uri=https://bfiledev.netlink.com/api/auth/calendly" : "https://auth.calendly.com/oauth/authorize?client_id=hUALsvqvT91JNB8crNJiAhQZGwRB09jriZsLfXfhG_E&response_type=code&redirect_uri=https://beta.bfilesystem.com/api/auth/calendly";

    return (
      <div>
        <Card
          type="inner"
          title={<Translate text={`Personal Information`} />}
          loading={loading}
          style={{ marginBottom: 20 }}
        >
          <div>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`First Name`} /><span className="required-symbol">*</span>
                  </label>
                  <Input
                    value={user.first_name}
                    onChange={(e) => updateField("first_name", e.target.value)}
                    maxLength={50}
                  />
                </div>
              </Col>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Last Name`} /><span className="required-symbol">*</span>
                  </label>
                  <Input
                    value={user.last_name}
                    onChange={(e) => updateField("last_name", e.target.value)}
                    maxLength={50}
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={16}>
              {/* <Col md={12} span={24}>
                                <div className="inputField">
                                    <label><Translate text={`Email`} />:</label>
                                    <Input value={user.email} onChange={(e) => updateField('email', e.target.value)} />
                                </div>
                            </Col> */}
              <Col md={24} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Language`} /><span className="required-symbol">*</span>
                  </label>
                  <Select
                    defaultValue={user.language}
                    style={{ width: "100%" }}
                    onChange={(value) => updateField("language", value)}
                  >
                    <Option value={""}>
                      <Translate text={`Select Language`} />
                      ...
                    </Option>
                    <Option value="en">
                      <Translate text={`English`} />
                    </Option>
                    <Option value="es">
                      <Translate text={`Spanish`} />
                    </Option>
                  </Select>
                </div>
              </Col>
            </Row>
            {/* <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <label>
                    <Translate
                      text={`Virtual Meeting Link (Zoom, WebEx etc.)`}
                    />
                    :
                  </label>
                  <Input
                    value={user.virtual_link}
                    onChange={(e) =>
                      updateField("virtual_link", e.target.value)
                    }
                  />
                </div>
              </Col>
            </Row> */}

            <Row gutter={16}>
              <Col md={24} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Upload Profile Photo`} />
                    {/* <Translate text={`Upload Profile Photo`} /> <span className="required-symbol">*</span> */}
                  </label>
                  {/* <Input value={users.name} onChange={(e) => updateField('name', e.target.value)} /> */}
                  <Dropzone
                    accept={['image/png', 'image/jpg', 'image/jpeg']}
                    maxFiles={1}
                    onDrop={(files, reject) => {

                      if (!files.length && reject.length && reject.map(e => e.errors[0])[0].code === 'too-many-files') {
                        message.error('Please select only one photo')
                      } else {

                        files = files.map(file => Object.assign(file, {
                          preview: URL.createObjectURL(file)
                        }))

                        fileAttributes_upload('profile_pic',
                          {
                            ...fileAttributes,
                            profile_pic: [...files],

                          })
                      }

                    }
                    }
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="container">
                        <div className="disp-flex">
                          <div
                            {...getRootProps({
                              className: 'dropzone',
                              onDrop: (event) => event.stopPropagation(),
                            })}
                          >
                            <input {...getInputProps()} />
                            <span className="btn-drop">Browse</span>
                          </div>
                          <p>
                            Image files (.jpg, .png) here, click to select files.
                          </p>
                        </div>
                        <div className="box-bors">
                          <h4>Uploaded File :</h4>
                          {fileAttributes.profile_pic &&
                            fileAttributes.profile_pic.map((pic, index) => (
                              <li key={index} className="pic-display-position">
                                <Icon
                                  type="close"
                                  className="cross-close"
                                  onClick={() => this.showDeleteConfirm("profile_pic", index)}
                                />
                                <img style={{ width: '100px' }} src={pic.preview}
                                  onLoad={() => URL.revokeObjectURL(pic.preview)} />
                                {/* {pic.path} <br /> <b>Size : </b>
                                {(pic.size / (1024 * 1024)).toFixed(2)} MB */}
                              </li>
                            ))}
                          {!fileAttributes.profile_pic.length && user.dp_url &&
                            <li className="pic-display-position">
                              <Icon
                                type="close"
                                className="cross-close"
                                onClick={() => this.showDeleteConfirm("dp_url", user.id)}
                              />
                              <img style={{ width: '100px' }} src={user.dp_url} />
                            </li>}
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>
              </Col>
            </Row>


            <div>
              {
                (userType === "EA" || userType === "LSP") && (
                  <div>
                    <h2>
                      <Translate text={`Appointment Links`} />
                    </h2>
                    <SchedulingLink
                      parentInstance={this.props.parentInstance}
                      type_of_call={TYPE_OF_SCHEDULING_CALL.REVIEW}
                    // schedule_meetings={this.props.schedule_meetings}
                    />
                  </div>
                )
              }
            </div>


            {/* {!this.props.has_calendly ? (
              <div>
                <h2>
                  <Translate text={`Connect Calendly`} />
                </h2>
                <a href={calendly_connect}>
                  <Button>Connect Calendly</Button>
                </a>
                <br />
                <br />
              </div>
            ) : (
              <div>
                <h2>
                  <Translate text={`Connect Calendly`} />
                </h2>
                <Button onClick={() => this.props.logoutCalendly()}>
                  Logout
                </Button>
                <br />
                <br />
              </div>
            )} */}

            {/* {this.props.has_calendly ? (
              <div>
                <h2>
                  <Translate text={`Calendly Settings`} />
                </h2>
                <Row gutter={16}>
                  <Col md={12} span={24}>
                    <div className="inputField">
                      <label>
                        <Translate text={`RS Setup Appointment Event Type`} />:
                      </label>
                      <Select
                        // defaultValue={user.calendly_rs_setup_appointment}
                        defaultValue={F.getSelectedCalendlyEventType(
                          user.calendly_rs_setup_appointment,
                          this.props.calendly_event_types
                        )}
                        style={{ width: "100%" }}
                        onChange={(value) =>
                          updateField("calendly_rs_setup_appointment", value)
                        }
                      >
                        <Option value={null}>
                          <Translate text={`Select Event Type`} />
                          ...
                        </Option>
                        {this.props.calendly_event_types.map(
                          (event_type, i) => (
                            // <Option key={i} value={"https://api.calendly.com/event_types/"+event_type.id}>{event_type.attributes.name}</Option>
                            <Option key={i} value={event_type.uri}>
                              {event_type.name}
                            </Option>
                          )
                        )}
                      </Select>
                    </div>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col md={12} span={24}>
                    <div className="inputField">
                      <label>
                        <Translate text={`VO Setup Appointment Event Type`} />:
                      </label>
                      <Select
                        // defaultValue={user.calendly_vo_setup_appointment}
                        defaultValue={F.getSelectedCalendlyEventType(
                          user.calendly_vo_setup_appointment,
                          this.props.calendly_event_types
                        )}
                        style={{ width: "100%" }}
                        onChange={(value) =>
                          updateField("calendly_vo_setup_appointment", value)
                        }
                      >
                        <Option value={null}>
                          <Translate text={`Select Event Type`} />
                          ...
                        </Option>
                        {this.props.calendly_event_types.map(
                          (event_type, i) => (
                            // <Option key={i} value={"https://api.calendly.com/event_types/"+event_type.id}>{event_type.attributes.name}</Option>
                            <Option key={i} value={event_type.uri}>
                              {event_type.name}
                            </Option>
                          )
                        )}
                      </Select>
                    </div>
                  </Col>
                </Row>
              </div>
            ) : null} */}

            {/* <Microsoft_booking {...this.props} /> */}
            {/* <ManualMicrosoftBooking {...this.props} /> */}
            <Row gutter={16}>
              <Col md={24} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Internal System Calendar`} />:
                  </label>
                  <Collapse>
                    {[
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                    ].map((day, i) => (
                      <Panel header={day} key={i}>
                        <div className="checkboxes">
                          {this.props.appointment_hours[day].map((hour, h) => (
                            <span key={day + "_" + hour.value}>
                              <Checkbox
                                checked={hour.checked}
                                onChange={(e) =>
                                  this.props.update_appointment_hours(
                                    day,
                                    h,
                                    e.target.checked
                                  )
                                }
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    minWidth: 75,
                                  }}
                                >
                                  {hour.value}
                                </span>
                              </Checkbox>
                            </span>
                          ))}
                        </div>
                      </Panel>
                    ))}
                  </Collapse>
                </div>
              </Col>
            </Row>

            <h2>
              <Translate text={`Update Password`} />
            </h2>
            <Row gutter={16}>
              <Col md={12} span={24}>
                <div className="inputField">
                  <Button onClick={() => this.props.requestPassword()}
                    className="borderRadius-28"
                  >
                    <Translate text={`Request a new Password`} />
                  </Button>
                </div>
              </Col>
            </Row>
            {/* <h2>
              <Translate text={`Notifications`} />
            </h2> */}
            {/* <Row gutter={16}> */}
              {/* <Col md={12} span={24}>
                <div className="inputField">
                  <Switch
                    checked={user.email_cron_notification ? true : false}
                    onChange={(checked) =>
                      updateField("email_cron_notification", checked ? 1 : 0)
                    }
                  />
                  <span style={{ marginLeft: 10 }}>
                    <Translate text={`Reminder Notifications`} />
                  </span>
                </div>
              </Col> */}
              {/* <Col md={12} span={24}>
                <div className="inputField">
                  <Switch
                    checked={user.email_game_notification ? true : false}
                    onChange={(checked) =>
                      updateField("email_game_notification", checked ? 1 : 0)
                    }
                  />
                  <span style={{ marginLeft: 10 }}>
                    <Translate text={`Gamification Notifications`} />
                  </span>
                </div>
              </Col> */}
              {/* <Col md={12} span={24}>
                <div className="inputField">
                  <Switch
                    checked={user.email_sale_notification ? true : false}
                    onChange={(checked) =>
                      updateField("email_sale_notification", checked ? 1 : 0)
                    }
                  />
                  <span style={{ marginLeft: 10 }}>
                    <Translate text={`Sale Notifications`} />
                  </span>
                </div>
              </Col> */}
            {/* </Row> */}
          </div>
          <div className="right-align">
            <Button type="primary" onClick={update.bind(this)}
              className="bg-164897 borderRadius-28"
            >
              <Translate text={`${UPDATE_PROFILE}`} />
            </Button>
          </div>
        </Card>
        {/* {link !== "" ? (
          <Card
            type="inner"
            title={<Translate text={`External B File Creation Link`} />}
          >
            <div>
              <p>
                This link will allow your customers to fill out the B File on
                their own time.
              </p>
              <TextArea
                id="linkTextarea"
                prefix={
                  <Icon type="link" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                value={link}
                style={{ marginBottom: 10 }}
              />
              <div className="right">
                <Button onClick={() => this.copyToClipboard()}>
                  Copy Intelligence Link
                </Button>
              </div>
            </div>
          </Card>
        ) : null} */}
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/scenes/Profile/lsp.js